"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardGrid = _interopRequireDefault(require("UIComponents/card/UICardGrid"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _BizObjectivesMap = _interopRequireDefault(require("self-service-api/constants/BizObjectivesMap"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _HighlightedMerchBizObjectives = _interopRequireDefault(require("self-service-api/constants/HighlightedMerchBizObjectives"));

var _HighlightedMerchHeaderConfig = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _reactRedux = require("react-redux");

var _ExperimentTreatmentSelectors = require("../../selectors/ExperimentTreatmentSelectors");

var _ChecklistItem = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ChecklistItem"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    > div {\n      grid-template-columns: 1fr;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 0;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    color: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BizObjHeaderLink = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "BizObjectives__BizObjHeaderLink",
  componentId: "sc-72jw47-0"
})(["font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:", " !important;", ";"], _colors.CALYPSO_DARK, _responsiveBreakpoints.default.tablet(_templateObject(), _colors.CALYPSO_DARK));

var BizObjHeaderNoLink = _styledComponents.default.h6.withConfig({
  displayName: "BizObjectives__BizObjHeaderNoLink",
  componentId: "sc-72jw47-1"
})(["font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:", " !important;", ";"], _colors.CALYPSO_DARK, _responsiveBreakpoints.default.tablet(_templateObject2(), _colors.CALYPSO_DARK));

var BizObjWrapper = (0, _styledComponents.default)(_UICardSection.default).withConfig({
  displayName: "BizObjectives__BizObjWrapper",
  componentId: "sc-72jw47-2"
})(["", ";"], _responsiveBreakpoints.default.phone(_templateObject3()));

var BizLowerTierContainer = _styledComponents.default.div.withConfig({
  displayName: "BizObjectives__BizLowerTierContainer",
  componentId: "sc-72jw47-3"
})(["font-size:14px;line-height:19px;padding-bottom:12px;"]);

var BizCmsWrapper = _styledComponents.default.div.withConfig({
  displayName: "BizObjectives__BizCmsWrapper",
  componentId: "sc-72jw47-4"
})(["min-height:300px;", ";", ";"], _responsiveBreakpoints.default.tablet(_templateObject4()), _responsiveBreakpoints.default.tabletPortrait(_templateObject5()));

var BizObjectives = function BizObjectives(_ref) {
  var merchandiseId = _ref.merchandiseId,
      inSingleColumnPriceDisplay = _ref.inSingleColumnPriceDisplay,
      hub = _ref.hub,
      isExperimentTreatmentRequestLoading = _ref.isExperimentTreatmentRequestLoading;

  var onBizObjHeaderClick = function onBizObjHeaderClick(bizObjKey) {
    return (0, _getUsageTracker.default)().track('bizObjectiveClick', {
      bizObjectiveKey: bizObjKey,
      isLink: Boolean(_BizObjectivesMap.default[bizObjKey].breakoutData)
    });
  };

  var renderBizObjectiveHeader = function renderBizObjectiveHeader(bizObjKey) {
    var bizObj = _BizObjectivesMap.default[bizObjKey];

    var textNode = _react.default.createElement(_FormattedMessage.default, {
      message: "pricing-pages.bizObjectives." + bizObjKey
    });

    if (bizObj.breakoutData) {
      return _react.default.createElement(BizObjHeaderLink, {
        use: "link",
        onClick: (0, _partial.default)(onBizObjHeaderClick, bizObjKey)
      }, textNode);
    }

    return _react.default.createElement(BizObjHeaderNoLink, {
      onClick: (0, _partial.default)(onBizObjHeaderClick, bizObjKey)
    }, textNode);
  };

  var renderBizObjective = function renderBizObjective(bizObjKey) {
    return _react.default.createElement("div", {
      key: bizObjKey,
      className: inSingleColumnPriceDisplay ? 'm-bottom-9' : null
    }, renderBizObjectiveHeader(bizObjKey), _BizObjectivesMap.default[bizObjKey].features.map(function (feature) {
      return _react.default.createElement(_ChecklistItem.default, {
        key: feature,
        tooltipMessage: (0, _getFeatureDescriptionKey.default)(feature, hub),
        message: "pricing-pages.features." + feature + ".name",
        className: "m-y-1"
      });
    }));
  };

  if (inSingleColumnPriceDisplay) {
    var headerConfig = _HighlightedMerchHeaderConfig.default[merchandiseId];
    var lowerTierPlus = headerConfig.lowerTierPlus;
    if (isExperimentTreatmentRequestLoading) return null;
    return _react.default.createElement(BizObjWrapper, {
      className: "p-top-0",
      "data-selenium-id": "biz-objectives"
    }, _react.default.createElement(BizLowerTierContainer, null, _react.default.createElement(_FormattedMessage.default, {
      message: lowerTierPlus
    })), _HighlightedMerchBizObjectives.default[merchandiseId].map(function (bizKey) {
      return renderBizObjective(bizKey);
    }));
  }

  return _react.default.createElement(BizCmsWrapper, null, _react.default.createElement(_UICardGrid.default, {
    columns: 2
  }, _HighlightedMerchBizObjectives.default[merchandiseId].map(function (bizKey) {
    return renderBizObjective(bizKey);
  })));
};

BizObjectives.propTypes = {
  merchandiseId: _propTypes.default.number.isRequired,
  hub: _propTypes.default.string.isRequired,
  inSingleColumnPriceDisplay: _propTypes.default.bool,
  isExperimentTreatmentRequestLoading: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isExperimentTreatmentRequestLoading: (0, _ExperimentTreatmentSelectors.isExperimentTreatmentRequestLoadingSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(BizObjectives);

exports.default = _default;
module.exports = exports.default;